import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import KeywordFormContainer from '../../../../Containers/AdminContainer/Keywords/KeywordsForm';
const KeywordFormScreen = () => {
  return <KeywordFormContainer />;
};

export default KeywordFormScreen;
